// Base component of Appxigon React implementation
import { get, includes, isEmpty, random } from 'lodash'
import React from 'react'
import { bindActionCreators} from 'redux'
import { connect } from 'react-redux'
import Modal from 'react-bootstrap/lib/Modal'
import EventListener, {withOptions} from 'react-event-listener'

import * as Actions from './redux/actions'
import View from './view.js'
import {_t, getCurrentRouteId, validUserLogin} from './lib/utils'

// make _t an i18n a global helper
window._t = _t

class Appxigon extends React.Component {

  constructor(props) {
    super(props)

    this.viewHistory = []

    var schema = this.props.schema
    var account = this.props.account
    // TODO: if not found, set currentViewId as first view ID
    var currentViewId = get(schema, 'views.default', 'default')

    this.state = {
      env           : this.props.env,
      account       : account,
      currentViewId : currentViewId,

      classes       : get(schema, 'classes.app', 'container'),
      classesHeader : get(schema, ['classes','app.header'], 'container'),
      classesFooter : get(schema, ['classes','app.footer'], 'container'),
      AXGClasses     : get(schema, 'classes', {}),
      AXGOptions     : get(schema, 'options', {}),
      AXGDataSource : get(schema, 'data', {}),
    }
  }

  validateLogin(signinViewId, defaultViewId) {
    signinViewId = signinViewId || 'signin'
    defaultViewId = defaultViewId || 'dashboard'

    const p = this.props
    const signinRouteIds = [ 'signin', '' ]
    const currentRouteId = getCurrentRouteId()
    const isSigninRoute = includes(signinRouteIds, currentRouteId)
    // console.info(`_ auth: login(${validUserLogin()}), currentRouteId(${currentRouteId}), isSigninRoute(${isSigninRoute})`)
    if (!isSigninRoute && !validUserLogin()) {
      // redirect to siginin route
      p.actions.setViewId({viewId: signinViewId})
      console.info(` ... redirect: (${currentRouteId}) -> ${signinViewId}`)
    }
    if (isSigninRoute && validUserLogin()) {
      // redirect to siginin route
      p.actions.setViewId({viewId: defaultViewId})
      console.info(` ... redirect: (${signinViewId}) -> ${defaultViewId}`)
    }
  }

  componentWillMount() {
    const checkInterval = 2000
    const c = this
    setInterval(
      ()=> {
        c.validateLogin()
      },
      checkInterval
    )
  }

  componentWillReceiveProps(nextProps) {
    const component = this
    const { schema, account } = nextProps
    let newViewId = nextProps.currentViewId
    // console.log(this.props.schema === schema ? 'Same schema' : 'schema changed')
    // Set currentViewId to the default viewId of the new schema
    if ( schema.id !== this.props.schema.id ) {
      newViewId = get(schema, 'views.default', 'default')
    }
    // console.log(`Appxigon: newViewId / schema: ${newViewId} / ${schema}`)
    component.setState({
      account       : account,
      env           : nextProps.env,
      currentViewId : newViewId,

      classes       : get(schema, 'classes.app', 'container'),
      classesHeader : get(schema, ['classes','app.header'], 'container'),
      classesFooter : get(schema, ['classes','app.footer'], 'container'),
      AXGClasses    : get(schema, 'classes', {}),
      AXGOptions    : get(schema, 'options', {}),
      AXGDataSource : get(schema, 'data', {}),
    })
  }

  // TODO: generic signal handling
  // use Actor Model ?
  handleKeyPress(e) {
    const actions = this.props.actions
    let key = e.key
    let signal = JSON.parse(e.target.getAttribute('data-signal'))
    // console.log(`${e.target.id}: ${JSON.stringify(signal)}: key pressed: ${key}`)
    if (signal) {
      switch (key) {
        case 'Enter':
          let itemId = signal.Enter
          // console.info(`_ "Enter" pressed for: ${itemId}`)
          // console.info(`_ Update dependency for: ${itemId}`)
          actions.setAppxigonState({
            key : `dependency.${itemId}`,
            value: JSON.stringify(random(5, true)),
          })
          break;
      }
    }
  }

  render() {
    const [ c, p, s ] = [ this, this.props, this.state ]
    const routeViewId = p.params.viewId
    const defaultViewId = get(p.schema, 'views.default', 'default')

    const title = get(p, 'schema.title', 'title')
    document.title = _t(title)

    const stateViewId = s.currentViewId
    const currentViewId = routeViewId || stateViewId || defaultViewId
    // console.log(`routeViewId / stateViewId: ${routeViewId} / ${stateViewId}`)
    // Update locale
    window.i18n.default = p.currentLocale
    // console.log(`Appxigon: currentViewId: ${JSON.stringify(currentViewId)}`)
    var viewSchema = get(p, `schema.views.${currentViewId}`, {})
    if (isEmpty(viewSchema)) {
      viewSchema = get(p, `schema.views.${defaultViewId}`, {})
    }
    // console.log(`Appxigon: viewSchema: ${JSON.stringify(viewSchema)}`)

    // Modal Hacking
    // FIXME: leave to custom.css ?
    const padding = 90; // adjust this to your needs
    let height = (s.contentHeight + padding);
    let heightPx = height + 'px';
    let heightOffset = height / 2;
    let offsetPx = heightOffset + 'px';

    let style = {}
    if (p.modalStyle == 'custom') {
      style = {
        content: {
          border: '0',
          borderRadius: '4px',
          bottom: 'auto',
          height: heightPx,  // set height
          // height: '1000px',  // set height
          left: '50%',
          padding: '2rem',
          position: 'fixed',
          right: 'auto',
          top: '50%', // start from center
          transform: 'translate(-50%,-' + offsetPx + ')', // adjust top "up" based on height
          width: '40%',
          maxWidth: '40rem'
        }
      }
    }

    const modalViewSchema = p.modalViewSchema || null
    const modalViewTitle = _t(get(p.modalViewSchema, 'title'))
    const modalId = p.modalStyle != '' ? `appxigon-modal-${p.modalStyle}` : 'appxigon-modal'
    const modal =
      <Modal
        id={modalId}
        lang={p.currentLocale}
        show={p.modalDisplay}
        onHide={p.actions.closeModal}
        style={style}
      >
        <Modal.Header id="appxigon-modal-header" closeButton>
          <Modal.Title id="appxigon-modal-title">
            { modalViewTitle }
          </Modal.Title>
        </Modal.Header>
        <Modal.Body id="appxigon-modal-body">
          {/* {JSON.stringify(modalViewSchema)} */}
          <View
            env={p.env}
            id={`modal-${currentViewId}`}
            locale={p.currentLocale}
            account={s.account}
            AXGClasses={s.AXGClasses}
            AXGOptions={s.AXGOptions}
            AXGDataSource={s.AXGDataSource}
            schema={modalViewSchema}/>
        </Modal.Body>
      </Modal>

    return (
      <div className={s.classes}>
        {
          get(p, 'schema.views.header')
          &&
          <View
            env={p.env}
            id='header'
            locale={p.currentLocale}
            isHeader={true}
            account={s.account}
            AXGClasses={s.AXGClasses}
            AXGOptions={s.AXGOptions}
            AXGDataSource={s.AXGDataSource}
            schema={get(p, 'schema.views.header')}/>
        }
        <div>
          <View
            env={p.env}
            id={currentViewId}
            locale={p.currentLocale}
            account={s.account}
            AXGClasses={s.AXGClasses}
            AXGOptions={s.AXGOptions}
            AXGDataSource={s.AXGDataSource}
            schema={viewSchema}/>
        </div>
        {
          get(p, 'schema.views.footer')
          && <div className={s.classesFooter}>&lt;app.footer&gt;</div>
        }
        { modal }
        <EventListener target={document} onKeyUpCapture={this.handleKeyPress.bind(this)} />

      </div>
    )
  }
}

Appxigon.ItemTypes = require('./item-types')
Appxigon.addItemType = Appxigon.ItemTypes.addItemType
Appxigon.addItemTypes = Appxigon.ItemTypes.addItemTypes

function mapStateToProps(s) {
  const localeSelectorKey = get(s, ['AXGSchema', 'schema', 'locale-selector'], 'locale')
  const defaultLocale = get(s, ['AXGSchema', 'schema', 'locale'], 'en')
  return {
    currentLocale: get(s, ['AXGState', localeSelectorKey], defaultLocale),
    currentViewId: s.AXGView.current,
    modalViewSchema: s.AXGView.modalViewSchema,
    modalDisplay: s.AXGView.modalDisplay,
    modalTitle: s.AXGView.modalTitle,
    modalStyle: s.AXGView.modalStyle,
    schema: s.AXGSchema.schema,
    account: s.AXGAccount,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Appxigon)



// WEBPACK FOOTER //
// ./appxigon.js